import { StatFilter, StatFilterType } from "../../../compounds/EliasStatsFilter/filter-stats-utils";
import { FinderSelectOptionType } from "../../../compounds/FastFilters/constants";

export const PAGE_TITLE = 'NBA Player Consecutive Points Finder';
export const PAGE_SUBTITLE =
  'Search the most complete and accurate NBA database for consecutive points for a player.';

export const runOptions: FinderSelectOptionType[] = [
  { id: 'none', label: 'Any' },
  { id: 'start', label: 'To Start Game' },
  { id: 'end', label: 'To End Game' },
];

export const DEFAULT_RUN_OPTION = runOptions[0].id;

export const groupByOptions: FinderSelectOptionType[] = [
  { id: 'none', label: 'None' },
  { id: 'team', label: 'Team instances' },
  { id: 'team-season', label: 'Team within a season' },
  { id: 'team-opponent', label: 'Team against an opponent' },
];

export const DEFAULT_GROUP_BY_STATUS = groupByOptions[0].id;

export const statsFilters: StatFilter[] = [
  {
    id: 'team_pts',
    abbr: 'Consec Team PTS',
    name: 'Player\'s scoring run, accounting for team points only. Min 10 PTS',
    year: 1997,
    type: StatFilterType.equality,
  },
  {
    id: 'game_pts',
    abbr: 'Consec Game PTS',
    name: 'Player\'s scoring run, accounting for team and opp points. Min 10 PTS',
    year: 1997,
    type: StatFilterType.equality,
  },
]
